import React from 'react';
import { SearchIcon } from 'lucide-react';
interface DataDirectoryHeroProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export function DataDirectoryHero({
  searchQuery,
  setSearchQuery
}: DataDirectoryHeroProps) {
  return <section className="pt-24 pb-12 bg-white" data-id="element-714">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-715">
        <h1 className="text-4xl md:text-5xl font-bold text-blue-600 mb-6" data-id="element-716">
          All local business categories
        </h1>
        <p className="text-xl text-slate-600 mb-10 leading-relaxed" data-id="element-717">
          Browse our complete local business database of 300+ business types.
          Find the perfect local business listings for your needs.
        </p>

        <div className="relative max-w-2xl mx-auto" data-id="element-718">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-719">
            <SearchIcon className="h-5 w-5 text-slate-400" data-id="element-720" />
          </div>
          <input type="text" className="block w-full pl-11 pr-4 py-4 border border-slate-200 rounded-xl text-base placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm" placeholder="Search categories..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-721" />
        </div>
      </div>
    </section>;
}